import { action } from 'satcheljs';

/**
 * Action triggered when we initialise or change the search text
 */
export default action('setSearchText', function setSearchText(text: string) {
    return { text };
});
